import * as React from 'react';
import theme from '../../utils/theme';

export interface BaseFormProps {
  children: any;
  id?: string;
  label: string;
  tooltip?: string;
  className?: string;
}

export const BaseForm = ({
  label,
  id,
  tooltip,
  children,
  className = '',
}: BaseFormProps) => (
  <div className={`${theme.form.field.panel} ${className}`}>
    <label htmlFor={id} className={theme.form.field.label}>
      {label}
    </label>
    {children}
    {tooltip && <small className={theme.form.field.tooltip}>{tooltip}</small>}
  </div>
);
